class Cluster {
  constructor(coordinates, network, chargersList) {
    this.geometry = { coordinates: coordinates };
    this.network = network;
    this.chargersList = chargersList;
  }

  assignCharger(charger) {
    this.chargersList.push(charger);
  }
}

export default Cluster;
